/**
 * PipedriveSidebar Component
 * Sidebar navigation for the Pipedrive data viewer
 */

import { CATEGORICAL } from '@/lib/theme'
import { pipedriveNavigationGroups } from '@/config/pipedriveNavigationConfig'
import { NavGroup } from './NavGroup'
import { NavItem } from './NavItem'

export function PipedriveSidebar() {
  return (
    <aside
      className="fixed left-0 top-16 bottom-0 w-60 border-r bg-background overflow-y-auto border-l-4"
      style={{ borderLeftColor: CATEGORICAL.clay.solid }}
      aria-label="Pipedrive sidebar navigation"
    >
      <div className="px-4 py-2 border-b" style={{ backgroundColor: CATEGORICAL.clay.tint }}>
        <span
          className="text-xs font-medium uppercase tracking-wide"
          style={{ color: CATEGORICAL.clay.solid }}
        >
          Pipedrive Data
        </span>
      </div>
      <nav className="p-4 space-y-2">
        {pipedriveNavigationGroups.map((group) => {
          // Standalone items (Dashboard)
          if (group.standalone && group.href) {
            return (
              <NavItem key={group.id} label={group.label} href={group.href} icon={group.icon} />
            )
          }

          // Grouped items (CRM, Activities, Catalog)
          if (group.items) {
            return (
              <NavGroup
                key={group.id}
                id={group.id}
                label={group.label}
                icon={group.icon}
                items={group.items}
                defaultExpanded={group.defaultExpanded}
              />
            )
          }

          return null
        })}
      </nav>
    </aside>
  )
}
